import { render, staticRenderFns } from "./ChristmasHelp.vue?vue&type=template&id=11c10eca&"
import script from "./ChristmasHelp.vue?vue&type=script&lang=js&"
export * from "./ChristmasHelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports